import { NotificationTypeEnum } from 'api/enums';
import { UserModel } from 'api/models';
import { Avatar } from 'library/avatar';
import {
    CalendarIcon,
    CameraIcon,
    ChatIcon,
    FileIcon,
    MessageIcon,
    PlusWindowIcon,
    UserIcon,
    VideoIcon,
} from 'library/icons';
import { FC, ReactNode } from 'react';

interface NotificationIconProps {
    type: NotificationTypeEnum;
    createdBy: Pick<UserModel, 'name' | 'dpUrl' | 'preset'> | null;
}

const NotificationIcon: FC<NotificationIconProps> = (props) => {
    const { type, createdBy } = props;

    const render = (params: { icon: ReactNode; bgClass: string }) => {
        return (
            <div className={['w-10 h-10 flex items-center justify-center rounded-full', params.bgClass].join(' ')}>
                {params.icon}
            </div>
        );
    };

    switch (type) {
        case NotificationTypeEnum.LIVELAPSE_GENERATED:
            return render({ icon: <VideoIcon className="text-success-600" />, bgClass: 'bg-success-100' });

        case NotificationTypeEnum.LIVELAPSE_FAILED:
            return render({ icon: <VideoIcon className="text-danger-600" />, bgClass: 'bg-danger-100' });

        case NotificationTypeEnum.MULTI_IMAGE_DOWNLOAD_GENERATED:
            return render({
                icon: <PlusWindowIcon width={17} height={14} className="text-success-600" />,
                bgClass: 'bg-success-100',
            });

        case NotificationTypeEnum.MULTI_IMAGE_DOWNLOAD_FAILED:
            return render({
                icon: <PlusWindowIcon width={17} height={14} className="text-danger-600" />,
                bgClass: 'bg-danger-100',
            });

        case NotificationTypeEnum.SCHEDULED_CAMERA_PROGRESS_REPORT_GENERATED:
            return render({
                icon: <FileIcon className="text-success-600" />,
                bgClass: 'bg-success-100',
            });

        case NotificationTypeEnum.PROJECT_CREATED:
            return render({
                icon: <FileIcon className="text-success-600" />,
                bgClass: 'bg-success-100',
            });
        case NotificationTypeEnum.CAMERA_CREATED:
            return render({
                icon: <CameraIcon width={18} height={14} className="text-success-600" />,
                bgClass: 'bg-success-100',
            });
        case NotificationTypeEnum.USER_INVITATION_EXPIRED:
            return render({
                icon: <CalendarIcon className="text-danger-600" />,
                bgClass: 'bg-danger-100',
            });
        case NotificationTypeEnum.SUPPORT_TICKET_REPLIED:
            return render({
                icon: <ChatIcon width={16} height={16} className="text-grayscale-400" />,
                bgClass: 'bg-grayscale-100',
            });
        case NotificationTypeEnum.PROGRESS_LINE_POST_CREATED:
        case NotificationTypeEnum.PROGRESS_LINE_POST_TAGGED:
        case NotificationTypeEnum.PROGRESS_LINE_POST_COMMENT_CREATED:
        case NotificationTypeEnum.PROGRESS_LINE_INTERACTED_POST_COMMENT_CREATED:
        case NotificationTypeEnum.PROGRESS_LINE_COMMENT_TAGGED:
        case NotificationTypeEnum.CAMERA_IMAGE_COMMENT_CREATED:
        case NotificationTypeEnum.CAMERA_IMAGE_COMMENT_TAGGED:
        case NotificationTypeEnum.CAMERA_IMAGE_COMMENT_REPLIED:
        case NotificationTypeEnum.PROJECT_ACCESS_GRANTED:
        case NotificationTypeEnum.PROJECT_ACCESS_REVOKED:
        case NotificationTypeEnum.USER_INVITATION_ACCEPTED:
        case NotificationTypeEnum.USER_CREATED:
        case NotificationTypeEnum.DOCUMENT_ACCESS_GRANTED:
        case NotificationTypeEnum.DOCUMENT_ACCESS_REVOKED:
        case NotificationTypeEnum.DOCUMENT_FILE_ACCESS_GRANTED:
        case NotificationTypeEnum.DOCUMENT_FILE_ACCESS_REVOKED:
        case NotificationTypeEnum.DOCUMENT_EXTERNAL_LINK_ACCESS_GRANTED:
        case NotificationTypeEnum.DOCUMENT_EXTERNAL_LINK_ACCESS_REVOKED:
        case NotificationTypeEnum.SITE_WALK_FIELD_NOTE_CREATED:
        case NotificationTypeEnum.SITE_WALK_FIELD_NOTE_TAGGED:
        case NotificationTypeEnum.CAMERA_IMAGE_COMMENT_REPLY_TAGGED:
        case NotificationTypeEnum.SITE_WALK_FIELD_NOTE_CLOSED:
        case NotificationTypeEnum.SITE_WALK_FIELD_NOTE_REPLIED:
        case NotificationTypeEnum.SITE_WALK_FIELD_NOTE_REPLY_TAGGED:
            // case NotificationTypeEnum.SUPPORT_TICKET_REPLIED:
            return createdBy ? (
                <Avatar src={createdBy.dpUrl} alt={createdBy.name} backgroundColor={createdBy.preset.color} size={40} />
            ) : (
                <div className="bg-grayscale-100 w-10 h-10 rounded-full grid place-items-center">
                    <UserIcon className="text-grayscale-400" />
                </div>
            );
        case NotificationTypeEnum.SITE_WALK_UPLOADED:
            return render({
                icon: <VideoIcon className="text-success-600" />,
                bgClass: 'bg-success-100',
            });
        case NotificationTypeEnum.CUSTOM_PUSH_NOTIFICATION:
            // return <Avatar src={null} alt={'Notification'} size={40} />;
            return render({
                icon: <MessageIcon width={24} height={24} className="text-grayscale-600" />,
                bgClass: 'bg-grayscale-100',
            });
        default:
            return null;
    }
};

export default NotificationIcon;
